var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8249 53.6672H19.9017C19.4234 53.6672 19.0782 53.2013 19.2227 52.7426L23.2952 39.7509C23.3881 39.4537 23.6632 39.252 23.9739 39.252H40.753C41.0637 39.252 41.3392 39.4541 41.4321 39.7509L45.5039 52.7426C45.647 53.2003 45.3042 53.6672 44.8249 53.6672Z",
    fill: "#FFCF71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0919 40.6753H11.6348C6.32202 40.6753 2 36.3529 2 31.0401V12.6349C2 7.32202 6.32202 3 11.6348 3H53.0926C58.4058 3 62.7282 7.32237 62.7282 12.6349V31.0401C62.7275 36.3529 58.4054 40.6753 53.0919 40.6753Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0687 3H53.018V7.89572C53.018 8.28863 52.6988 8.60752 52.3062 8.60752H40.7802C40.3876 8.60752 40.0684 8.28863 40.0684 7.89572V3H40.0687Z",
    fill: "#FA3C48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3636 34.6563C25.2955 34.6563 19.5449 28.9057 19.5449 21.8376C19.5449 14.7691 25.2955 9.01855 32.3636 9.01855C39.4321 9.01855 45.1827 14.7691 45.1827 21.8376C45.1827 28.9057 39.4325 34.6567 32.3636 34.6567V34.6563Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4656 30.3576C11.2834 30.3576 11.1016 30.2879 10.9628 30.1487C6.37025 25.5534 6.36812 18.1215 10.9628 13.5265C11.6258 12.8635 12.6319 13.8707 11.9692 14.533C7.933 18.5653 7.93264 25.1106 11.9689 29.1426C12.4194 29.5928 12.0927 30.3576 11.466 30.3576H11.4656Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4695 27.3527C14.2872 27.3527 14.105 27.283 13.9666 27.1442C11.034 24.2102 11.0326 19.4632 13.9666 16.5292C14.6289 15.8669 15.6365 16.873 14.9734 17.536C12.5971 19.9124 12.5957 23.7628 14.9731 26.1381C15.4226 26.5876 15.099 27.3524 14.4698 27.3524L14.4695 27.3527Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2615 30.3574C52.6344 30.3574 52.3073 29.5929 52.7579 29.1424C56.7966 25.1079 56.7934 18.5683 52.7579 14.5328C52.0948 13.8698 53.1027 12.864 53.7647 13.5263C58.3565 18.1234 58.3601 25.5528 53.7647 30.1485C53.6256 30.2876 53.4433 30.3574 53.2615 30.3574Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2568 27.3532C49.6286 27.3532 49.3033 26.5881 49.7532 26.1379C52.1316 23.758 52.1284 19.9086 49.7532 17.5358C49.0898 16.8731 50.0977 15.8667 50.76 16.5293C53.6923 19.4648 53.6951 24.2014 50.76 27.1443C50.6209 27.2842 50.4386 27.3532 50.2568 27.3532Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2186 63.0001H9.5082C8.60422 63.0001 8.7964 61.89 8.7964 61.1014C8.7964 56.2177 12.7693 52.2441 17.6529 52.2441H47.0731C51.9568 52.2441 55.9296 56.2177 55.9296 61.1014C55.9296 61.8918 56.1222 63.0001 55.2179 63.0001H55.2186Z",
    fill: "#FFA800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.363 30.4365C27.6225 30.4365 23.7656 26.5793 23.7656 21.8384C23.7656 17.0974 27.6225 13.2402 32.363 13.2402C37.1039 13.2402 40.9612 17.0971 40.9612 21.8384C40.9612 26.58 37.1039 30.4365 32.363 30.4365Z",
    fill: "#808080"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3628 26.9513C29.5434 26.9513 27.25 24.6576 27.25 21.8378C27.25 19.0184 29.5434 16.7246 32.3628 16.7246C35.1822 16.7246 37.4763 19.0184 37.4763 21.8381C37.4763 24.6579 35.1822 26.9513 32.3628 26.9513Z",
    fill: "#044472"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8714 19.3966C28.6345 17.9979 30.0317 16.9936 31.6735 16.7715C32.1454 17.205 32.4419 17.8271 32.4419 18.5168C32.4419 19.824 31.3785 20.8871 30.0716 20.8871C29.0755 20.8871 28.2209 20.2692 27.8711 19.3966H27.8714Z",
    fill: "#166DAB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5334 21.8243C29.6216 21.8243 28.8799 21.0823 28.8799 20.1705C28.8799 19.2586 29.6216 18.5166 30.5334 18.5166C31.4452 18.5166 32.1872 19.2583 32.1872 20.1705C32.1872 21.0826 31.4452 21.8243 30.5334 21.8243Z",
    fill: "#D6E3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1543 50.0438C63.1543 49.5828 62.7805 49.209 62.3193 49.209C61.8581 49.209 61.4842 49.5828 61.4842 50.0438C61.4842 54.1283 58.1615 57.451 54.0771 57.451C49.9928 57.451 46.6701 54.1283 46.6701 50.0438C46.6701 49.5828 46.2963 49.209 45.8351 49.209C45.3738 49.209 45 49.5828 45 50.0438C45 54.7677 48.6269 58.6592 53.2422 59.0822V61.3302H50.1432C49.682 61.3302 49.3081 61.704 49.3081 62.1652C49.3081 62.6264 49.682 63.0003 50.1432 63.0003H58.0111C58.4721 63.0003 58.8462 62.6264 58.8462 62.1652C58.8462 61.704 58.4721 61.3302 58.0111 61.3302H54.9121V59.0822C59.5274 58.6595 63.1543 54.7677 63.1543 50.0438Z",
    fill: "#3B4958"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.077 55.3903C51.129 55.3903 48.7305 52.9918 48.7305 50.0435V40.3466C48.7305 37.3986 51.129 35 54.077 35C57.0252 35 59.4238 37.3986 59.4238 40.3466V50.0435C59.4238 52.9918 57.0252 55.3903 54.077 55.3903Z",
    fill: "#044472"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcam);
export default __webpack_public_path__ + "static/media/webcam.d6f71bc3b489d87605a52015e1356bcd.svg";
export { ForwardRef as ReactComponent };